export default __webpack_public_path__ + "static/media/money_boy_footer-min.01e53768.png";